import { TeamNanoID } from '../teams/teamsTypes';

export class TeamInvitationCache {
  static teamTeamInvitations(teamNanoId: TeamNanoID) {
    return `team-${teamNanoId}-team-invitations`;
  }
}
